import { useLiquidationAlertsWatcher } from '../store/watchers/useLiquidationAlertsWatcher';

export const LiquidationAlertsWatcher = () => {
  useLiquidationAlertsWatcher();
  return null;
};
